import { ProfileURL } from "../../shared/profileURL";


export const ViewResumeAnchor: React.FC = () => {
  return (
    <a
      href={ProfileURL.resume}
      target="_blank"
      rel="noopener noreferrer"
      className={`bg-primary-600 font-medium rounded-lg text-black text-sm  flex px-4  py-2 items-center gap-3 w-fit 
        border-[2px] border-solid border-transparent transition-all duration-300
        hover:border-primary-600 hover:bg-transparent hover:text-primary-600 hover:bg-dark-600
        font-inter
        `}
    >
      <span>See Resume</span>
      {/* <Icon icon="mingcute:eye-line" /> */}
    </a>
  );
};